import React, { useEffect, useState } from "react";

import * as echarts from "echarts";
import { addMinutes, format } from "date-fns";

export default function LidarViewSlider({ data, updateSelectedDttm }) {
    const [slider, setSlider] = useState(null);

    useEffect(() => {
        let viewSlider = echarts.init(document.getElementById("lidarSlider"));

        const handleDownplay = (index) => {
            let currentDatum = data[index];

            if (currentDatum) {
                updateSelectedDttm(currentDatum[0]);
            }
        };

        if (data?.length) {
            viewSlider.on("highlight", (evt, data) => {
                handleDownplay(evt.batch[0].dataIndex);
            });
        }

        window.onresize = function () {
            viewSlider.resize();
        };

        setSlider(viewSlider);
    }, [data, updateSelectedDttm]);

    useEffect(() => {
        if (slider && data) {
            const createSlider = () => {
                if (slider) {
                    let option = {
                        responsive: true,
                        useUTC: true,
                        title: {},
                        legend: {
                            top: "bottom",
                            data: [""],
                        },
                        tooltip: {
                            triggerOn: "none",
                            position: function (pt) {
                                return [pt[0], 130];
                            },
                        },
                        xAxis: {
                            type: "time",
                            axisPointer: {
                                value: data[data.length - 1][0],
                                snap: true,
                                lineStyle: {
                                    color: "#7581BD",
                                    width: 2,
                                },
                                label: {
                                    show: false,
                                    formatter: function (params) {
                                        let date = new Date(params.value);
                                        let utcOffset = date.getTimezoneOffset();
                                        let utcDate = addMinutes(date, utcOffset);
                                        let formattedDate = format(utcDate, "yyyy-MM-dd HH:mm:ss");
                                        formattedDate += " (UTC)";

                                        return formattedDate;
                                    },
                                    backgroundColor: "#7581BD",
                                },
                                handle: {
                                    show: true,
                                    color: "#7581BD",
                                    size: 35,
                                },
                            },
                            splitLine: {
                                show: false,
                            },
                        },
                        yAxis: {
                            type: "value",
                            axisTick: {
                                inside: true,
                            },
                            splitLine: {
                                show: false,
                            },
                            axisLabel: {
                                inside: true,
                                formatter: "{value}\n",
                            },
                            z: 10,
                        },
                        grid: {
                            top: 25,
                            left: 25,
                            right: 25,
                            height: 100,
                        },
                        dataZoom: [
                            {
                                type: "inside",
                                throttle: 50,
                            },
                        ],
                        series: [
                            {
                                name: "Point Count",
                                type: "line",
                                smooth: true,
                                symbol: "circle",
                                symbolSize: 5,
                                sampling: "average",
                                itemStyle: {
                                    color: "#004C83",
                                },
                                stack: "a",
                                areaStyle: {
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        {
                                            offset: 0,
                                            color: "#0083CA",
                                        },
                                        {
                                            offset: 1,
                                            color: "#CAE7F6",
                                        },
                                    ]),
                                },
                                data: data,
                            },
                        ],
                    };

                    option && slider.setOption(option);
                }
            };

            createSlider();
        }
    }, [slider, data]);

    return <div id="lidarSlider" style={{ width: "100%", height: "100%" }}></div>;
}
